<mat-expansion-panel [expanded]="expanded" (opened)="getLazyLoadedPropertyFieldsOfGroup(); "
  [class.mandatory-fields-incomplete]="getMandatoryStatus() === 'incomplete'" style="margin-bottom: 10px;">
  <mat-expansion-panel-header [attr.aria-label]="getHeaderAriaLabel(propertyGroup.label)">
    <mat-panel-title>
      <span class="label">{{propertyGroup.label}}</span>
      <span *ngIf="getMandatoryStatus() === 'incomplete'" class="mandatory-status incomplete"
        aria-hidden="true">*</span>
      <span *ngIf="getMandatoryStatus() === 'complete'" class="mandatory-status complete" aria-hidden="true">
          *
      </span>
      <span class="fill-remaining-space"></span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <p *ngIf="propertyGroup.description?.en">{{propertyGroup?.description?.en}}</p>

  <div *ngFor="let property of propertyGroup.properties" class="form-row">
    <ng-container [ngSwitch]="property.propertyType">
      <ng-container *ngIf="notChoiceProperty(property.key)">
        <!-- [copyProperty]="property" -->
        <im-property-switch 
          *ngSwitchDefault 
          [property]="property" 
          [copyProperty]="property"
          [parentFormGroup]="parentFormGroup.controls[getControlName()]"
          [readonly]="readonly"
          [fromChoice]="fromChoice"
          [featureAccessRights]="featureAccessRights"
          [beginPosition]="beginPosition" 
          [effectiveDate]="effectiveDate">
        </im-property-switch>
        <!-- [test]="parentFormGroup.controls[1]" [controlName]="getControlName()" -->
        <mat-expansion-panel *ngSwitchCase="'lazyLoaded'"
          [class.mandatory-fields-incomplete]="getMandatoryStatus(property) === 'incomplete'"
          [class.mandatory-fields-complete]="getMandatoryStatus(property) === 'complete'">
          <mat-expansion-panel-header [attr.aria-label]="getHeaderAriaLabel(property.label, property)">
            <mat-panel-title>
              <span>{{property.label}}</span>
              <span *ngIf="getMandatoryStatus(property) === 'incomplete'"
                class="mandatory-status incomplete" aria-hidden="true">*</span>
              <span *ngIf="getMandatoryStatus(property) === 'complete'" class="mandatory-status complete" aria-hidden="true">
                *
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p *ngIf="property.description?.en">{{property.description?.en}}</p>63.
        </mat-expansion-panel>
      </ng-container>
      

      <!-- Point of choice tpl -->
      <ng-container *ngSwitchCase="'choice'">
        <im-choice-field
          [id]="property.key"
          [property]="property"
          [propertyGroup]="propertyGroup"
          [parentFormGroup]="parentFormGroup"
          [positionInArray]="positionInArray"
          [readonly]="readonly"
          [fromChoice]="fromChoice"
          >
        </im-choice-field>
      </ng-container>
    </ng-container>
  </div>

  <mat-action-row *ngIf="propertyGroup.key !== 'aixm:annotation' && propertyGroup.key !== 'aixm:translatedNote'">
    <span class="field-buttons">
      <!-- Field-specific buttons for delete, annotations and info -->
      <button type="button" mat-icon-button [disabled]="readonly" matTooltip=" Set to nil"
        (click)="setToNil(); stopPropagation($event)">
        <mat-icon color="warn" aria-label="Set property to nil" [ngClass]="{'disable':readonly, 'enable': !readonly}">
          delete</mat-icon>
      </button>
      <button type="button" mat-icon-button matTooltip="Revert to initial value"
        (click)="revert(); stopPropagation($event)" [disabled]="readonly">
        <mat-icon color="primary" aria-label="Set property to nil"
          [ngClass]="{'disable':readonly, 'enable': !readonly}">undo</mat-icon>
      </button>
      <button type="button" mat-icon-button matTooltip="Annotations"
        *ngIf="propertyGroup.key !== 'aixm:annotation' && propertyGroup.key !== 'aixm:translatedNote'"
        (click)="showAnnotations? hideAnnotaion(): createAnnotation()" [disabled]="readonly && !propertyGroup.annotations">
        <mat-icon color="primary" aria-label="Annotations"
        [ngClass]="{'disable':readonly && !propertyGroup.annotations, 'enable': propertyGroup.annotations}">note</mat-icon>
      </button>
      <!-- <button type="button" mat-icon-button matTooltip="Property description"
        (click)="showInfo = !showInfo; stopPropagation($event)">
        <mat-icon color="primary" aria-label="Description">info</mat-icon>
      </button> -->
    </span>
  </mat-action-row>

  <div *ngIf="showAnnotations" class="indented">
    <!-- [arrayName]="getControlName() + '-annotations'" -->
    <im-property-switch [property]="propertyGroup.annotations"
    [parentFormGroup]="parentFormGroup.controls[getControlName()]" [arrayName]="'0-annotations'" [readonly]="readonly" [featureAccessRights]="featureAccessRights"
    [beginPosition]="beginPosition" [effectiveDate]="effectiveDate"></im-property-switch>
  </div>
</mat-expansion-panel>